import React from "react";

const Signup = () => {
  return <div>Page signup</div>;
};

export default Signup;
